export default __webpack_public_path__ + "static/media/verifiedHeader.64babcdf.svg";